// src/pages/TrackCreation/Step1.tsx
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import activeRadio from "../../../../../assets/images/radio_active.png";
import inactiveRadio from "../../../../../assets/images/radio_inactive.png";
import { useTranslation } from "react-i18next";
import { HotInfoContentProps, RouteParamsWithLanguage } from "../../../../../types/screensTypes";
import Button from "../../../../../components/ui/Button";
import { saveHotInfoTrack, getHotInfoById } from "../../../../../api";
import RadioButton from "../../../../../components/common/RadioButton";
import TitleSubtitle from "../../../../../components/common/TitleSubtitle";
import TextInput from "../../../../../components/ui/TextInput";
import { useTrackCreation } from "../../../../../context/TrackCreationContext";
import stepStyles from "../../createStep.module.css";
import partnerStyles from "./PartnerEdit.module.css";

const HotInfoContent: React.FC<HotInfoContentProps> = ({ navigateToNext }) => {
    const { trackData } = useTrackCreation();
    const [title, setTitle] = useState<string>("");
    const [website, setWebsite] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [checked, setChecked] = useState<boolean>(false);
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const { hotinfoId, language } = useParams<RouteParamsWithLanguage>();

    const saveHotInfo = async (): Promise<void> => {
        const token = localStorage.getItem("token");
        const trackId = trackData.trackId;

        if (!hotinfoId || !trackId || !token || !language) {
            return;
        }

        await saveHotInfoTrack({
            token,
            trackId,
            id: hotinfoId,
            name: title,
            website,
            phone,
            language,
            status: checked,
        });
        navigateToNext(hotinfoId, language);
    };

    const getHotInfo = async (id: string): Promise<void> => {
        const token = localStorage.getItem("token");
        if (!token || !language) {
            return;
        }
        const hotInfoData = await getHotInfoById({
            token,
            hotinfoId: id,
            language,
        });

        if (hotInfoData) {
            if (hotInfoData.infoChaudeLocalized && hotInfoData.infoChaudeLocalized.length > 0) {
                if (hotInfoData.infoChaudeLocalized[0].name !== "") {
                    setTitle(hotInfoData.infoChaudeLocalized[0].name);
                }
                if (hotInfoData.siteUrl) {
                    setWebsite(hotInfoData.siteUrl);
                }

                if (hotInfoData.phone) {
                    setPhone(hotInfoData.phone);
                }

                if (hotInfoData.status) {
                    setChecked(hotInfoData.status);
                }
            }
        }
    };

    useEffect(() => {
        if (hotinfoId && hotinfoId !== "") {
            getHotInfo(hotinfoId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hotinfoId, language]);

    return (
        <div className={`${stepStyles.editScreen} ${partnerStyles.screen}`}>
            <TitleSubtitle title={t("content")} subtitle={""} layout="edit" />

            <div className={partnerStyles.contentField}>
                <h4>{t("title")}</h4>
                <div className={partnerStyles.fieldNarrow}>
                    <TextInput
                        placeholder={t("title")}
                        value={title}
                        size="small"
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
            </div>

            <div className={partnerStyles.contentField}>
                <h4>{t("website")}</h4>
                <div className={partnerStyles.fieldNarrow}>
                    <TextInput
                        placeholder={t("website")}
                        value={website}
                        size="small"
                        onChange={(e) => setWebsite(e.target.value)}
                    />
                </div>
            </div>

            <div className={partnerStyles.contentField}>
                <h4>{t("phone")}</h4>
                <div className={partnerStyles.fieldNarrow}>
                    <TextInput
                        placeholder={t("phone")}
                        value={phone}
                        size="small"
                        onChange={(e) => setPhone(e.target.value)}
                    />
                </div>
            </div>

            <div className={partnerStyles.contentField}>
                <h4>{t("display")}</h4>
                <p>{t("indicateHereIfYouWantToDisplayThePartnerInApp")}</p>
                <RadioButton
                    label={t("yes")}
                    subtitle=""
                    checked={checked}
                    onChange={() => setChecked(true)}
                    activeImage={activeRadio}
                    inactiveImage={inactiveRadio}
                    textSize="small"
                    center={true}
                />

                <div style={{ marginTop: "10px" }}>
                    <RadioButton
                        label={t("no")}
                        subtitle=""
                        checked={!checked}
                        onChange={() => setChecked(false)}
                        activeImage={activeRadio}
                        inactiveImage={inactiveRadio}
                        textSize="small"
                        center={true}
                    />
                </div>
            </div>

            <div className={`${stepStyles.stepButton} ${stepStyles.footer}`}>
                <Button
                    variant="primary"
                    shape="pill"
                    className={`${stepStyles.continueBtn} ${partnerStyles.continueBtn}`}
                    label={t("continue")}
                    onClick={saveHotInfo}
                />
            </div>
        </div>
    );
};

export default HotInfoContent;
